/**
 * Assainissement des chemins avant stockage dans une miette.
 *
 * Le chemin d'un appel API peut porter une query-string (dernier vecteur résiduel
 * de fuite de contenu : recherche, filtres textuels…) ou une origine. On ne garde
 * que le chemin, sans origine, sans query-string, sans fragment.
 */
export function sanitizePath(input: string): string {
  if (!input) return '';
  const noFragment = input.split('#', 1)[0] ?? '';
  const noQuery = noFragment.split('?', 1)[0] ?? '';
  const originStripped = noQuery.replace(/^[a-z]+:\/\/[^/]+/i, '');
  return originStripped || noQuery;
}
